import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import Tabs, {Tab} from 'react-best-tabs'
import {getAllUsers, getInvestorsforRound} from '../core/_requests'
import {CreateAllActivity} from '../components/CreateAllActivity'
import {useAuth} from '../../auth'

export const AddNewActivityModal = ({
  investorName,
  modalShow,
  setModalShow,
  investorId,
  getActivity,
  selectedInvestorUser,
  roundId,
}: {
  investorName:string
  modalShow: boolean
  setModalShow: Dispatch<SetStateAction<boolean>>
  investorId?: number
  getActivity?: () => void
  selectedInvestorUser?: {label: string; value: number} | undefined
  roundId?: number | undefined
}) => {
  const {formatMessage} = useIntl()
  const [key, setKey] = useState(1)
  const [allInvestors, setAllInvestors] = useState<any>()
  const [allUsers, setAllUsers] = useState<any>()
  const {companyId} = useAuth()

  const [searchInvestor, setSearchInvestor] = useState<string>('')

  //getInvestor API
  useEffect(() => {
    const getInvestorsData = async () => {
      try {
        const {
          data: {
            success,
            data: {data: allApiInvestors},
          },
        } = await getInvestorsforRound(searchInvestor, roundId, 1, 12)
        if (success) {
          let investors: any = []
          investors = allApiInvestors?.map((investor: any) => {
            return {
              id: investor.investorId,
              label: investor.name,
              value: investor.investorId,
            }
          })
          if (investors.length > 0) {
            setAllInvestors(investors)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    if(roundId)
    getInvestorsData()
  }, [roundId, searchInvestor])

  const onSearchChange = (value: string) => {
    setSearchInvestor(value)
  }
  useEffect(()=>{
    if(investorName){
setSearchInvestor(investorName)
    }
  },[investorName])
  useEffect(() => {
    const getAllUser = async () => {
      if (companyId) {
        const {
          data: {data: values, success},
        } = await getAllUsers(companyId)
        if (success) {
          let users: any = []
          users = values.map((user: any) => {
            return {
              id: user.userId,
              name: `${user?.firstName} ${user?.lastName}`,
              value: user.userId,
            }
          })
          if (users.length > 0) {
            setAllUsers(users)
          }
        }
      }
    }
    getAllUser()
  }, [companyId])
  return (
    <Modal
      size='xl'
      show={modalShow}
      onHide={() => setModalShow(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <div className='fs-4 fw-bold'>
          <h2>{formatMessage({id: 'Add new activity'})}</h2>
        </div>
      </Modal.Header>
      <Modal.Body className='py-3'>
        <div className='pb-4'>
          <Tabs
            activeTab={key}
            className=''
            ulClassName='text-muted dark-border'
            activityClassName='bg-primary'
            onClick={(event, tab) => setKey(tab)}
          >
            <Tab title='Email' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                onSearchChange={onSearchChange}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='email'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                roundId={roundId}
              />
            </Tab>
            <Tab title='Call' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='call'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                onSearchChange={onSearchChange}
                roundId={roundId}
              />
            </Tab>
            <Tab title='Meeting' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='meeting'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                onSearchChange={onSearchChange}
                roundId={roundId}
              />
            </Tab>
            <Tab title='Tasks' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='tasks'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                onSearchChange={onSearchChange}
                roundId={roundId}
              />
            </Tab>
            <Tab title='Notes' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='notes'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                onSearchChange={onSearchChange}
                roundId={roundId}
              />
            </Tab>
            <Tab title='Documents' className='mr-3'>
              <CreateAllActivity
                modalShow={modalShow}
                setModalShow={setModalShow}
                allInvestors={allInvestors}
                allUsers={allUsers}
                type='documents'
                companyId={companyId!}
                investorId={investorId}
                getActivity={getActivity}
                selectedInvestorUser={selectedInvestorUser}
                onSearchChange={onSearchChange}
                roundId={roundId}
              />
            </Tab>
          </Tabs>
        </div>
      </Modal.Body>
    </Modal>
  )
}
